import { flow } from 'lodash';
import CompleteSentence from './CompleteSentence';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';

export default flow(withUserInput, withValidation)(CompleteSentence);



// WEBPACK FOOTER //
// ../core/src/components/CompleteSentence/index.js